export default __webpack_public_path__ + "static/media/Tsugami Rem Sales.187af1c0.png";